import { render, staticRenderFns } from "./ShippingboTracking.vue?vue&type=template&id=0c07c4e4&scoped=true&"
import script from "./ShippingboTracking.vue?vue&type=script&lang=js&"
export * from "./ShippingboTracking.vue?vue&type=script&lang=js&"
import style0 from "./ShippingboTracking.vue?vue&type=style&index=0&id=0c07c4e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07c4e4",
  null
  
)

export default component.exports